import {
  type RowClickFunction,
  Datagrid,
  SingleFieldList,
  TextField,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";
import { DateFieldWithStandardFormat } from "@/fields/DateFieldWithStandardFormat";
import { ReferenceTextArrayField } from "@/fields/ReferenceTextArrayField";
import { LandingField } from "@/modules/landings/components/LandingField";

type Props = {
  data: unknown[] | undefined;
  isPending?: boolean;
  withDates?: boolean;
  onClickRow?: RowClickFunction;
};

export const CampaignTdsDataGrid = ({
  data,
  isPending,
  withDates,
  onClickRow,
}: Props) => {
  return (
    <Datagrid
      resource={MODULE_NAMES.CAMPAIGN_TDS}
      isPending={isPending}
      data={data}
      rowClick={onClickRow}
      bulkActionButtons={false}
    >
      <LandingField source="landing" sortable={false} />
      <ReferenceTextArrayField
        source="countrySet"
        module={MODULE_NAMES.COUNTRIES}
        idField="code"
      >
        <SingleFieldList linkType={false} flexDirection="column">
          <TextField source="name" />
        </SingleFieldList>
      </ReferenceTextArrayField>
      <ReferenceTextArrayField
        source="modelSet"
        module={MODULE_NAMES.APPLE_MODELS}
        idField="slug"
      >
        <SingleFieldList linkType={false} flexDirection="column">
          <TextField source="title" />
        </SingleFieldList>
      </ReferenceTextArrayField>
      <ReferenceTextArrayField
        source="osSet"
        module={MODULE_NAMES.OS}
        idField="slug"
      >
        <SingleFieldList linkType={false} flexDirection="column">
          <TextField source="title" />
        </SingleFieldList>
      </ReferenceTextArrayField>
      {withDates && (
        <DateFieldWithStandardFormat source="createdAt" sortable={false} />
      )}
      {withDates && (
        <DateFieldWithStandardFormat source="updatedAt" sortable={false} />
      )}
    </Datagrid>
  );
};
